export enum WebviewSuccessActionsTypes {
    Meeting = "meeting",
    StartOver = "start_over",
    Redirect = "redirect",
    Message = "message",
    RedirectToLiveProfile = "redirectToLiveProfile",
    DownloadVCard = "downloadVCard",
}
